import api from '../api';
import { AppSettings } from '../models/app-settings';

export class AppSettingsService {
    static getAppSetting = () => api.get<AppSettings>('settings');
}
